var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg04Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56.4019,
    height: 56.4019,
    rx: 28.2009,
    fill: "#2A71FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6055 37.6015C18.4022 37.6015 16.7247 36.8003 15.5729 35.1979C14.4212 33.5955 13.8454 31.2921 13.8454 28.2876C13.8454 25.2831 14.4212 22.9797 15.5729 21.3773C16.7247 19.7749 18.4022 18.9737 20.6055 18.9737C22.8087 18.9737 24.4862 19.7749 25.638 21.3773C26.7897 22.9797 27.3655 25.2831 27.3655 28.2876C27.3655 31.3171 26.7897 33.6206 25.638 35.223C24.4862 36.8254 22.8087 37.6015 20.6055 37.6015ZM20.6055 35.273C23.2594 35.273 24.5864 32.9446 24.5864 28.2876C24.5864 23.6307 23.2594 21.3022 20.6055 21.3022C17.9515 21.3022 16.6495 23.6307 16.6495 28.2876C16.6495 32.9446 17.9515 35.273 20.6055 35.273ZM40.7909 30.566H43.1694V32.8945H40.7909V37.2009H38.1119V32.8945H29.2987V30.3407L37.8615 19.3743H40.7909V30.566ZM38.1369 30.566V22.529L31.8776 30.566H38.1369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04Blue);
export default __webpack_public_path__ + "static/media/04-blue.dfc5cb0de5ccb86c5754fde900feefee.svg";
export { ForwardRef as ReactComponent };